import { ArrowDownIcon } from './icons';

/** Voice-note waveform bar heights (px) — fixed so the illustration renders identically every time. */
const WAVEFORM = [6, 12, 18, 10, 22, 14, 8, 16, 24, 12, 6, 18, 20, 10, 14, 8, 12, 18, 6, 10];

const SAMPLE_LINES = [
  { item: 'Glucose Biscuit 100g', qty: '10 case', decision: 'auto', label: 'Auto' },
  { item: 'Sugar (loose)', qty: '5 kg', decision: 'auto', label: 'Auto' },
  { item: 'Mustard Oil 1L', qty: '12 btl', decision: 'review', label: 'Review' },
] as const;

/**
 * A static picture of the flow: WhatsApp voice note → structured order.
 * Plain markup, no screenshots, so the hero costs no image download.
 */
export const HeroIllustration = ({ caption }: { caption: string }) => (
  <figure className="lp-illustration">
    <div className="lp-chat">
      <div className="lp-chat__meta">Retailer · WhatsApp</div>
      <div className="lp-chat__voice" aria-hidden="true">
        <span className="lp-chat__play" />
        <span className="lp-chat__wave">
          {WAVEFORM.map((h, i) => (
            <span key={i} style={{ height: h }} />
          ))}
        </span>
        <span className="lp-chat__time">0:14</span>
      </div>
      <p className="lp-chat__transcript" lang="hi">
        “भैया, ग्लूकोज़ बिस्किट 10 पेटी, चीनी 5 किलो और सरसों तेल 12 बोतल भेज देना”
      </p>
    </div>

    <div className="lp-illustration__arrow">
      <ArrowDownIcon />
    </div>

    <div className="lp-order">
      <div className="lp-order__head">
        <span>Sales order</span>
        <span className="lp-order__state">Awaiting approval</span>
      </div>
      <ul className="lp-order__lines">
        {SAMPLE_LINES.map((l) => (
          <li key={l.item}>
            <span className="lp-order__item">{l.item}</span>
            <span className="lp-order__qty">{l.qty}</span>
            <span className={`lp-tag lp-tag--${l.decision}`}>{l.label}</span>
          </li>
        ))}
      </ul>
    </div>

    <figcaption>{caption}</figcaption>
  </figure>
);
